app.directive("acNavView", ['$rootScope', function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            
            var closeAllSubViews = function(){
                var subViews = $(element).find("[ac-view]");
                subViews.css("display", "none");
            }
            
            var openSubView = function(id){
                var mainView = $(element).find("[ac-view='"+id+"']");
                mainView.css("display", "block");
            }
            
            closeAllSubViews()
            openSubView(1)
            
            
            
            var navElements = $(element).find("[ac-view-switch]");
            
            navElements.on("click", function(el){
                var currentViewId = $(el.currentTarget).parents("[ac-view]").attr("ac-view")
                var switchViewId = $(el.currentTarget).attr("ac-view-switch");
                closeAllSubViews()
                openSubView(switchViewId)
                
                var targetView = $(element).find("[ac-view='"+switchViewId+"']");
                $(document).find(".ac-faq-switch").remove()
                var el = document.createElement("div");
                el.innerHTML = '<i class="material-icons">arrow_back</i>';
                el.setAttribute("class", "ac-faq-switch")
                //targetView.prepend('<div ac-view-switch="1" class="ac-faq-switch"></div>');
                
                targetView.prepend(el);
                
                $(el).on("click", function(el){
                    closeAllSubViews()
                    openSubView(currentViewId)
                })
                
            })
        }
    }
}]);